import whenDomReady from 'when-dom-ready';
whenDomReady().then(() => {
    const nav = document.querySelector('.js-nav');
    // don't stick for learn-navigation
    if (nav?.classList.contains('header--learn')) {
        return;
    }
    let prevScrollPos = window.pageYOffset;
    const ACTIVE = 'is-sticky';
    const navHeight = 109;
    if (nav) {
        window.addEventListener('scroll', () => {
            showNav();
        });
    }
    function showNav() {
        if (!nav) {
            return;
        }
        const currentScrollPos = window.pageYOffset;
        if (currentScrollPos < navHeight) {
            nav.classList.remove(ACTIVE);
        }
        else {
            if (prevScrollPos > currentScrollPos) {
                nav.classList.add(ACTIVE);
            }
            else {
                nav.classList.remove(ACTIVE);
            }
        }
        prevScrollPos = currentScrollPos;
    }
});
